module.exports = __webpack_public_path__ + "assets/nextTaskBtn.baa8196367c0717323e0447da033aade.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play-screen-ui/nextTaskBtn.svg
// module id = 123
// module chunks = 0